import type { RouteRecordRaw } from 'vue-router';
import loginRoutes from '@/modules/root/login/login.routes';
import dashboardRoutes from '@/modules/dashboard/dashboard.routes.children';
import administrationRoutes from '@/modules/administration/administration.routes.children';
import workspaceRoutes from '@/modules/workspace/workspace.routes.children';
import { authGuard } from './guards/auth.guard';
import annuaireRoutes from '@/modules/annuaire/annuaire.routes.children';

export default [
    {
        path: '',
        component: () => import('./root.vue'),
        children: [
            {
                path: '',
                component: () => import('./login/components/LoginContainer.vue'),
                redirect: {
                    name: 'login'
                },
                meta: {
                    requiresAuth: false
                },
                children: [
                    ...loginRoutes,
                ],
            },
            {
                path: 'app',
                component: () => import('@/shared/blocksUI/DefaultTemplate.vue'),
                meta: {
                    requiresAuth: true
                },
                beforeEnter: authGuard,
                children: [
                    ...dashboardRoutes,
                    ...administrationRoutes,
                    ...workspaceRoutes,
                    ...annuaireRoutes
                ],
            },
            {
                path: 'viewer',
                component: () => import('@/shared/blocksUI/DefaultTemplate.vue'),
                beforeEnter: authGuard,
                children: [
                    {
                        name: 'rootViewer',
                        path: '',
                        component: () => import('@/shared/blocksUI/viewer/AxViewer.vue'),
                    }
                ],
            },
            {
                name: 'QrScan',
                path: 'qr_scan',
                component: () => import('@/modules/root/qr_scan/QrScan.vue'),
                meta: {
                    requiresAuth: false
                },
            }
        ],
    },
] satisfies RouteRecordRaw[];
